export function formatDate(dateString, options = { dateStyle: "short" }) {
  const date = new Date(dateString);
  const formatter = new Intl.DateTimeFormat("en-US", options);

  return formatter.format(date);
}
